<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AddressItem" });
import * as API from "../../services/api.js";
import { ADDRESS_STORE } from "../../services/store.js";
import { OutputAddress } from "../../index.js";
export let key;
export let onError = void 0;
const fetchAddress = (key2) => {
    if (key2 === void 0) {
        return;
    }
    void API.fetchAddress({ addressKey: key2 }, onError);
};
$: fetchAddress(key);
</script>

{#if key !== undefined && key in $ADDRESS_STORE }

    <slot address = { $ADDRESS_STORE[key] }>

        <OutputAddress address = { $ADDRESS_STORE[key] } />

    </slot>

{/if}